import {
  ChartLabelItem,
  ChartLabelWrapper,
  StackedBookedRatioChartStyles,
  TextWrapper,
} from '@/chart/components/all-charts-styles';

export function BookedRatioHeader() {
  const { HeaderWrapper, TitleWrapper } = StackedBookedRatioChartStyles;

  return (
    <HeaderWrapper>
      <TitleWrapper>
        <TextWrapper>Vacant vs. Non-vacant</TextWrapper>
      </TitleWrapper>
      <ChartLabelWrapper>
        <ChartLabelItem color="rgba(0, 0, 0, 0.15)" text="Vacant" />
        <ChartLabelItem color="#37A3BC" text="Book" />
        <ChartLabelItem color="#c7d1f3" text="Block" />
      </ChartLabelWrapper>
    </HeaderWrapper>
  );
}
